import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M7.5 5H16.5M4 12H20M7.5 19H16.5" vectorEffect="non-scaling-stroke" />
	</SVG>
);
